var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94645 0.598267L8.56244 3.89221C8.28564 3.97525 8.03652 4.11365 7.7874 4.25205L4.49346 2.86804L2.50049 4.86101L3.8845 8.15495C3.74609 8.43176 3.63537 8.6532 3.52465 8.93L0.230713 10.314V13.082L3.52465 14.466C3.63537 14.7428 3.74609 14.9643 3.8845 15.2411L2.50049 18.535L4.49346 20.528L7.7874 19.144C8.03652 19.2547 8.28564 19.3931 8.56244 19.5038L9.94645 22.7978H12.7145L14.0985 19.5038C14.3476 19.3931 14.6244 19.2824 14.8735 19.144L18.1675 20.528L20.1604 18.535L18.7764 15.2411C18.8871 14.992 19.0255 14.7152 19.1363 14.466L22.4302 13.082V10.314L19.1363 8.93C19.0532 8.68088 18.9148 8.40407 18.7764 8.15495L20.1604 4.86101L18.1675 2.86804L14.8735 4.25205C14.6244 4.14133 14.3476 4.00293 14.0985 3.89221L12.7145 0.598267L9.94645 0.598267ZM11.3305 7.51831C13.6279 7.51831 15.4825 9.37288 15.4825 11.6703C15.4825 13.9678 13.6279 15.8224 11.3305 15.8224C9.03301 15.8224 7.17844 13.9678 7.17844 11.6703C7.17844 9.37288 9.03301 7.51831 11.3305 7.51831Z",
    fill: "#365644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParam);
export default __webpack_public_path__ + "static/media/param.afef5e7f373de265f0dbfa675de837b9.svg";
export { ForwardRef as ReactComponent };